<div class="trial-dialog-container">
    <button class="close-btn" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
    <div class="content-wrapper">
        <!-- Left Section: AI Interview -->
        <div class="section left-section">
            <div class="image-wrapper trial-image-wrapper">
                <img src="assets/images/Free-trial-interview.png" alt="AI Interview Practice" class="trial-img">
            </div>
            <h3 class="trial-title">Ace Your Next Interview</h3>
            <p class="trial-desc">Practice with our AI interviewer and get real-time feedback to boost your confidence.
            </p>
            <button class="btn btn-primary trial-btn" (click)="startInterviewPractice()">
                <span class="desktop-text">Start Free Interview Practice</span>
                <span class="mobile-text">Free Interview Practice</span>
            </button>
        </div>

        <!-- Vertical Divider (Visual separation via border) -->

        <!-- Right Section: Mock Test -->
        <div class="section right-section">
            <div class="image-wrapper trial-image-wrapper">
                <img src="assets/images/Free-trial-mocktest.png" alt="Mock Test Practice" class="trial-img">
            </div>
            <h3 class="trial-title">Level Up Your Preparation </h3>
            <p class="trial-desc">Take aptitude mock tests and track your performance with feedback to stay ahead of the
                competition.</p>
            <button class="btn btn-success trial-btn" (click)="startMockTest()">
                <span class="desktop-text">Start Free Mock Test</span>
                <span class="mobile-text">Free Mock Test</span>
            </button>
        </div>
    </div>
</div>